import { useTranslate } from '@festina-life/ui/hooks'
import { Table, TBody, Th, THead, Tr } from '@festina-life/ui/listsAndTables'

import { useTemplateContext } from '../../context/templateContext'
import { isNotRelevantField } from '../../types/templateModel'
import { TemplateReferenceAddMappingRow } from './TemplateReferenceAddMappingRow'
import { TemplateReferenceMappingsTableRow } from './TemplateReferenceMappingsTableRow'
import type { TemplateReferenceTableProps } from './types'
import { useUnusedMappingKeys } from './useUnusedMappingKeys'
import { useUnusedTemplateReferences } from './useUnusedTemplateReferences'

export const TemplateReferencesMappingTable = ({
  errors,
  field,
  onChange,
  rowClassName,
  isExpanded,
}: TemplateReferenceTableProps) => {
  const translate = useTranslate()
  const { isDraftTemplate } = useTemplateContext()
  const unusedKeyOptions = useUnusedMappingKeys(field)
  const unusedTemplateReferences = useUnusedTemplateReferences(field)

  return (
    <>
      {isDraftTemplate && isExpanded && !isNotRelevantField(field) && (
        <TemplateReferenceAddMappingRow field={field} />
      )}
      <Table className="table-fixed">
        <THead>
          <Tr>
            <Th className={`${rowClassName} w-2/3`}>
              {translate(
                'templateViewer.templateReferenceViewer.modal.columnHeader.key',
              )}
            </Th>
            <Th className={`${rowClassName} w-1/3`}>
              {translate(
                'templateViewer.templateReferenceViewer.modal.columnHeader.templateReference',
              )}
            </Th>
          </Tr>
        </THead>
        <TBody>
          {(field.value?.variants ?? []).map((templateVariant, index) => (
            <TemplateReferenceMappingsTableRow
              unusedKeyOptions={unusedKeyOptions}
              unusedSourceOptions={unusedTemplateReferences}
              errors={errors[index] ?? []}
              key={templateVariant.key}
              data={templateVariant}
              fieldPath={field.path}
              onChange={
                onChange ? (nextValue) => onChange(nextValue, index) : undefined
              }
            />
          ))}
        </TBody>
      </Table>
    </>
  )
}
